import { Href, router } from 'expo-router'

type RouterAction = 'back' | 'push' | 'navigate' | 'replace'
export interface RouterEvent {
  action: RouterAction
  href: Href
  preventDefault: boolean
}
type RouterCallback = (event: RouterEvent) => void

class Router {
  private listeners: RouterCallback[] = []

  addListener(callback: RouterCallback) {
    this.listeners.push(callback)
  }

  removeListener(callback: RouterCallback) {
    this.listeners = this.listeners.filter((listener) => listener !== callback)
  }

  back() {
    const event = {
      action: 'back' as RouterAction,
      href: '',
      preventDefault: false,
    }
    this.listeners.forEach((listener) => listener(event))
    if (!event.preventDefault) router.back()
  }

  navigate(href: Href) {
    const event = {
      action: 'navigate' as RouterAction,
      href,
      preventDefault: false,
    }
    this.listeners.forEach((listener) => listener(event))
    if (!event.preventDefault) router.navigate(href)
  }

  push(href: Href) {
    const event = {
      action: 'push' as RouterAction,
      href,
      preventDefault: false,
    }
    this.listeners.forEach((listener) => listener(event))
    if (!event.preventDefault) router.push(href)
  }

  replace(href: Href) {
    const event = {
      action: 'replace' as RouterAction,
      href,
      preventDefault: false,
    }
    this.listeners.forEach((listener) => listener(event))
    if (!event.preventDefault) router.replace(href)
  }

  dismiss(count?: number) {
    const event = {
      action: 'dismiss' as RouterAction,
      href: '',
      preventDefault: false,
    }
    this.listeners.forEach((listener) => listener(event))
    if (!event.preventDefault) router.dismiss(count)
  }

  dismissTo(href: Href) {
    const event = {
      action: 'dismissTo' as RouterAction,
      href,
      preventDefault: false,
    }
    this.listeners.forEach((listener) => listener(event))
    if (!event.preventDefault) router.dismissTo(href)
  }

  canGoBack() {
    return router.canGoBack()
  }

  setParams(params?: Record<string, any>) {
    router.setParams(params)
  }
}

export default Router
